"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var checkout4LiteMainRoutesContainerStyles = styles_1.makeStyles(function () { return ({
    root: {
        maxWidth: '1676px',
        margin: 'auto',
        width: '100%',
        paddingBottom: 40,
    },
}); }, { name: 'Checkout4_checkoutLiteMainRoutesContainer' });
exports.default = checkout4LiteMainRoutesContainerStyles;
